import { render, staticRenderFns } from "./visualEdit.vue?vue&type=template&id=353c98e0&scoped=true"
import script from "./visualEdit.vue?vue&type=script&lang=js"
export * from "./visualEdit.vue?vue&type=script&lang=js"
import style0 from "./visualEdit.vue?vue&type=style&index=0&id=353c98e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c98e0",
  null
  
)

export default component.exports